import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { useSelector } from 'react-redux';
import { getCurrentMonth } from '../utils';
import { parseSelectedTermMonths } from '../../terms/common/utils';

export const useGetFlexBuyCurrentMonths = () => {
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const selectedTermId = useSelector((state) => offerReduxSelectors.getTermIdByOfferType(state, offerType));
    const parsedSelectedTerm = parseSelectedTermMonths(selectedTermId);
    const flexBuyCurrentMonths = getCurrentMonth({ parseSelectedTermId: parsedSelectedTerm });

    return {
        flexBuyCurrentMonths
    };
};
